import { render, staticRenderFns } from "./Off.vue?vue&type=template&id=cf279838&scoped=true&"
import script from "./Off.vue?vue&type=script&lang=js&"
export * from "./Off.vue?vue&type=script&lang=js&"
import style0 from "./Off.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Off.vue?vue&type=style&index=1&id=cf279838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf279838",
  null
  
)

export default component.exports